import React, { Component } from 'react'
import Icon from './Icon'

class PositionIcon extends Component {
  render () {
    return (
      <Icon {...this.props}>
        <svg width='24px' height='23px' viewBox='0 0 24 23'>
          <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
            <g transform='translate(-22.000000, -786.000000)' fill='#7E8DA2'>
              <path
                d='M44.5,795.75 L23.5,795.75 L23.5,792 C23.5,791.172 24.172,790.5 25,790.5 L43,790.5 C43.828,790.5 44.5,791.172 44.5,792 L44.5,795.75 L44.5,795.75 Z M32.5,798 C32.5,797.7255 32.57875,797.472 32.70775,797.25 L35.29225,797.25 C35.42125,797.472 35.5,797.7255 35.5,798 C35.5,798.828 34.828,799.5 34,799.5 C33.172,799.5 32.5,798.828 32.5,798 L32.5,798 Z M44.5,805.5 C44.5,806.328 43.828,807 43,807 L25,807 C24.172,807 23.5,806.328 23.5,805.5 L23.5,797.25 L31.1065,797.25 C31.0435,797.49075 31,797.739 31,798 C31,799.65675 32.34325,801 34,801 C35.65675,801 37,799.65675 37,798 C37,797.739 36.9565,797.49075 36.8935,797.25 L44.5,797.25 L44.5,805.5 L44.5,805.5 Z M31,788.25 C31,787.836 31.336,787.5 31.75,787.5 L36.25,787.5 C36.664,787.5 37,787.836 37,788.25 L37,789 L31,789 L31,788.25 L31,788.25 Z M43,789 L38.5,789 L38.5,787.5 C38.5,786.672 37.828,786 37,786 L31,786 C30.172,786 29.5,786.672 29.5,787.5 L29.5,789 L25,789 C23.34325,789 22,790.34325 22,792 L22,805.5 C22,807.15675 23.34325,808.5 25,808.5 L43,808.5 C44.65675,808.5 46,807.15675 46,805.5 L46,792 C46,790.34325 44.65675,789 43,789 L43,789 Z'
                id='Fill-200'
              />
            </g>
          </g>
        </svg>
      </Icon>
    )
  }
}

export default PositionIcon
